import React from 'react'
import { Link } from 'react-router-dom'
import ProductStoreAdd from './ProductStoreAdd'

class ProductStoreAddTab extends React.Component {
  state = {}
  componentDidMount() {
    if (
      this.props.match.params.store_id !== undefined &&
      this.props.match.params.store_id !== null &&
      this.props.match.params.store_id !== 0 &&
      this.props.match.params.store_id !== ''
    ) {
      this.setState({ store_id: this.props.match.params.store_id })
    }
  }
  handleLanguage = (language_id) => {
    this.setState({ language_id: language_id })
  }
  render() {
    return (
      <div className="main-body">
        <div className="page-wrapper">
          <div className="page-header">
            <div className="row align-items-end">
              <div className="col-lg-8">
                <div className="page-header-title">
                  <div className="d-inline">
                    <h4>{this.props.match.params.store_id ? 'Edit' : 'Add'} Product Details</h4>
                  </div>
                </div>
              </div>
              <div className="col-lg-4">
                <div className="page-header-breadcrumb">
                  <ul className="breadcrumb-title">
                    <li className="breadcrumb-item">
                      <Link to="/">
                        <i className="feather icon-home"></i>{' '}
                      </Link>
                    </li>
                    <li className="breadcrumb-item">
                      <Link to={`/store-products/${this.props.match.params.storeDetail_id}`}>Product Details</Link>
                    </li>
                    <li className="breadcrumb-item active">
                      {this.props.match.params.store_id ? 'Edit' : 'Add'} Product Details
                    </li>
                  </ul>
                </div>
              </div>
            </div>
          </div>
          <div className="page-body">
            <div className="row">
              <div className="col-sm-12">
                <div className="card card-border-default">
                  <div className="tab-content tabs">
                    <div
                      className="tab-pane  active"
                      id={'add_Store_' + this.state.language_id}
                      role="tabpanel"
                      aria-labelledby=""
                    >
                      {this.state.store_id !== undefined &&
                      this.state.store_id !== null &&
                      this.state.store_id !== 0 &&
                      this.state.store_id !== '' ? (
                        <ProductStoreAdd
                          language_id={this.state.language_id}
                          goBack={this.props.history.goBack}
                          storeDetail_id={this.props.match.params.storeDetail_id}
                          store_id={this.state.store_id}
                        />
                      ) : (
                        <ProductStoreAdd
                          language_id={this.state.language_id}
                          goBack={this.props.history.goBack}
                          storeDetail_id={this.props.match.params.storeDetail_id}
                        />
                      )}
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    )
  }
}

export default ProductStoreAddTab
